import React from 'react';
import classNames from 'classnames';
import styles from './SVGIcon.scss';

export default function FourCirclesIcon({
  className,
  size = 'tiny',
  color = 'var(--color-icon-lineart)',
}) {
  return (
    <span className={classNames(styles.svgIcon, className, styles[size])}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.33333 5.41667C8.33333 7.0275 7.0275 8.33333 5.41667 8.33333C3.80584 8.33333 2.5 7.0275 2.5 5.41667C2.5 3.80584 3.80584 2.5 5.41667 2.5C7.0275 2.5 8.33333 3.80584 8.33333 5.41667Z"
          stroke={color}
          strokeWidth="1.667"
        />
        <path
          d="M17.5 5.41667C17.5 7.0275 16.1942 8.33333 14.5833 8.33333C12.9725 8.33333 11.6667 7.0275 11.6667 5.41667C11.6667 3.80584 12.9725 2.5 14.5833 2.5C16.1942 2.5 17.5 3.80584 17.5 5.41667Z"
          stroke={color}
          strokeWidth="1.667"
        />
        <path
          d="M8.33333 14.5833C8.33333 16.1942 7.0275 17.5 5.41667 17.5C3.80584 17.5 2.5 16.1942 2.5 14.5833C2.5 12.9725 3.80584 11.6667 5.41667 11.6667C7.0275 11.6667 8.33333 12.9725 8.33333 14.5833Z"
          stroke={color}
          strokeWidth="1.667"
        />
        <path
          d="M17.5 14.5833C17.5 16.1942 16.1942 17.5 14.5833 17.5C12.9725 17.5 11.6667 16.1942 11.6667 14.5833C11.6667 12.9725 12.9725 11.6667 14.5833 11.6667C16.1942 11.6667 17.5 12.9725 17.5 14.5833Z"
          stroke={color}
          strokeWidth="1.667"
        />
      </svg>
    </span>
  );
}
